module.exports = __webpack_public_path__ + "static/media/sg1sj.1e4903dc.png";